import { render, staticRenderFns } from "./CookiesBanner.vue?vue&type=template&id=afee18ec&scoped=true&"
import script from "./CookiesBanner.vue?vue&type=script&lang=js&"
export * from "./CookiesBanner.vue?vue&type=script&lang=js&"
import style0 from "./CookiesBanner.vue?vue&type=style&index=0&id=afee18ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afee18ec",
  null
  
)

export default component.exports